import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { SortTransformation } from '../../../dataflow/sorttransformation';
import { BaseSortTransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-sort-transformation.adapter';
import { isTruthy } from 'app/model/dataflow/dataflow-expression-utilities';
import { DataFlowExpressionUtils } from '../expression.util';
import { BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SortTransformation),
    asynchronous: true
})
export class SortTransformationAdapter extends BaseSortTransformationAdapter {
    protected getExtraDSLConfigs(sortTransformation: SortTransformation): string[] {
        return isTruthy(sortTransformation.partitionLevel)
            ? [
                  `partitionLevel: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                      sortTransformation.partitionLevel,
                      BooleanDataFlowType.TYPE
                  )}`
              ]
            : [];
    }
}
